import React from 'react'
import {Icon} from '@chakra-ui/react'

const CompareIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <g clipPath="url(#clip0_1082_1385)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.499023 0.499634H21.4993V32.3001H0.499023V0.499634ZM3.49902 3.49963V29.3001H18.4993V3.49963H3.49902Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.5 7.69983H39.5003V39.5003H18.5V7.69983ZM21.5 10.6998V36.5003H36.5003V10.6998H21.5Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.2988 22.1H37.999V25.1H26.2988V22.1Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.6385 17.1393L32.7598 19.2606L28.4204 23.6L32.7598 27.9395L30.6385 30.0608L24.1777 23.6L30.6385 17.1393Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.6992 17.8998H1.99902V14.8998H13.6992V17.8998Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5777 16.3998L7.23828 12.0604L9.3596 9.93909L15.8203 16.3998L9.3596 22.8606L7.23828 20.7393L11.5777 16.3998Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_1082_1385">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default CompareIcon
